import React, { Component } from "react";
import LanguageSelector from "../Components/LanguageSelector";
import { get, post } from "../Services/http";

class LanguageSelectorContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
        this.load();
    }

    load() {
        get("/api/languageselector")
            .then(response => response.json())
            .then(data => {
                this.setState({
                    loading: false,
                    languages: data.languages,
                });
            });
    }
    render() {
        return this.state.loading ? null : (
            <LanguageSelector
                languages={this.state.languages}
            />
        );
    }
}
export default LanguageSelectorContainer;